import { store, getContext, getElement } from '@wordpress/interactivity';
import GLightbox from 'glightbox';

const { state } = store('gt/thelis/hebergement/image', {
    actions:{
        openLightbox: (e) => {
            e.preventDefault();
            const context = getContext();
            let images = [];
            context.images.forEach(url => {
                images.push({
                    'href': url,
                    'type': 'image',
                });
            });

            const image = e.target;
            
            const clickedIndex = image.getAttribute('src') ? context.images.findIndex(href => href === image.getAttribute('src')) : 0;

            const gallery = GLightbox({
                elements: images,
                loop: true,
                zoomable: true,
                draggable: true,
                preload: true,
                startAt: clickedIndex == -1 ? 0 : clickedIndex,
            });

            gallery.open();
        }
    }
});
